import { cva, type VariantProps } from "class-variance-authority";

export interface ButtonProps
  extends
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

export const buttonVariants = cva(
  "relative inline-flex cursor-pointer items-center justify-center gap-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-linear-to-br from-primary-400 to-secondary-400 text-white transition-opacity hover:opacity-90",
        outline:
          "border border-border bg-white text-text-primary hover:bg-button-outline-hover",
        outlinePrimary:
          "border border-primary-400 bg-white text-primary-400 hover:bg-button-outline-hover",
        ghost: "hover:bg-background-secondary",
        link: "font-medium text-primary-400 hover:underline",
        tertiary: "bg-tertiary-400 text-white hover:opacity-90",
        tertiarySecondary:
          "border-tertiary-400/5 bg-tertiary-100 text-tertiary-400 hover:bg-tertiary-150",
        quaternary:
          "border border-grey-200 bg-grey-100 text-black-400 hover:bg-file-upload-hover",
        gradientBorder: "shrink-0 border border-transparent",
        gradientBorderSubtle: "shrink-0 border border-transparent",
        plain: "",
      },
      size: {
        default: "h-10 px-6",
        sm: "h-9 px-5",
        xs: "h-8 rounded-md px-4",
        // lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
        iconSm: "h-9 w-9",
        iconXs: "h-8 w-8 rounded-md",
        iconXxs: "h-7 w-7 rounded-md",
        link: "h-auto",
        pill: "rounded-full px-2 py-0.5 text-xs font-medium",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
    compoundVariants: [
      {
        variant: "tertiarySecondary",
        size: "pill",
        className: "border border-tertiary-400/5",
      },
    ],
  },
);
